/**
 * @fileoverview gRPC-Web generated client stub for mycargo.projects.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/cargoloop.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var projects_erp_service_api_v1_model_cl_buyer_pb = require('./cl_buyer_pb.js')

var projects_erp_service_api_v1_model_cl_localtransportation_pb = require('./cl_localtransportation_pb.js')
const proto = {};
proto.mycargo = {};
proto.mycargo.projects = {};
proto.mycargo.projects.erp = {};
proto.mycargo.projects.erp.api = {};
proto.mycargo.projects.erp.api.v1 = {};
proto.mycargo.projects.erp.api.v1.services = require('./cargoloop_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.CargoloopClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.CargoloopPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsResponse>}
 */
const methodDescriptor_Cargoloop_ListLocalTransportations = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Cargoloop/ListLocalTransportations',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsRequest,
  proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.CargoloopClient.prototype.listLocalTransportations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Cargoloop/ListLocalTransportations',
      request,
      metadata || {},
      methodDescriptor_Cargoloop_ListLocalTransportations,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListLocalTransportationsResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.CargoloopPromiseClient.prototype.listLocalTransportations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Cargoloop/ListLocalTransportations',
      request,
      metadata || {},
      methodDescriptor_Cargoloop_ListLocalTransportations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListBuyersRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListBuyersResponse>}
 */
const methodDescriptor_Cargoloop_ListBuyers = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Cargoloop/ListBuyers',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListBuyersRequest,
  proto.mycargo.projects.erp.api.v1.services.ListBuyersResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListBuyersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListBuyersResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListBuyersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListBuyersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListBuyersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.CargoloopClient.prototype.listBuyers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Cargoloop/ListBuyers',
      request,
      metadata || {},
      methodDescriptor_Cargoloop_ListBuyers,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListBuyersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListBuyersResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.CargoloopPromiseClient.prototype.listBuyers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Cargoloop/ListBuyers',
      request,
      metadata || {},
      methodDescriptor_Cargoloop_ListBuyers);
};


module.exports = proto.mycargo.projects.erp.api.v1.services;

